import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { Portal } from 'react-portal';

import { ApplicationModule } from 'shared/modules';
import { useNavigate, useStore } from 'shared/hooks';
import { UiIcon } from 'shared/uikit-new';
import { ROUTES } from 'shared/constants';

import './styles.scss';

type PropsType = {
    children?: React.ReactNode;
    className?: string;
    title?: string;
    subtitle?: React.ReactNode,
    backTo?: string | [string, object] | (() => void);
    widgets?: boolean
}

export const LayoutContentTitle = observer((
    {
        title,
        className,
        subtitle,
        backTo,
        children
    }: PropsType,
) => {
    const navigate = useNavigate();

    const store = useStore(() => ({
        headerTitle: null as null | Element
    }));

    useEffect(() => {
        ApplicationModule.setTitle(title);
        store.headerTitle = document.getElementsByClassName('layout-header__title')[0];
    }, [title]);

    const handleBack = () => {
        if (typeof backTo === 'string') {
            navigate(backTo);
            return;
        }
        if (Array.isArray(backTo)) {
            navigate(backTo[0], backTo[1] || {});
            return;
        }
        if (typeof backTo === 'function') {
            backTo();
            return;
        }
        if (window.history.state?.idx > 0) {
            navigate(-1);
            return;
        }
    };

    return (
        <Portal node={document && store.headerTitle}>
            <div className={classnames('layout-content-title', className)}>
                <div className="layout-content-title__inner">
                    <div className="layout-content-title__title">
                        {backTo && (
                            <div onClick={handleBack} className="layout-content-title__back">
                                <UiIcon.ChevronLeft/>
                            </div>
                        )}
                        <span>{title}</span>
                        {!!children && (
                            <div className="layout-content-title__aside">{children}</div>
                        )}
                    </div>
                    {subtitle && (
                        <div className="layout-content-title__subtitle">
                            {subtitle}
                        </div>
                    )}
                </div>
                <div className="layout-content-title__search" onClick={() => navigate(ROUTES.SEARCH())}>
                    <UiIcon.Search size={24} />
                </div>
            </div>
        </Portal>
    );
});
